"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeterReadsSummary = void 0;
var react_1 = __importDefault(require("react"));
var mappings_1 = require("../../../../shared/api/mappings");
var core_1 = require("../../../../shared/core");
var copy_1 = require("./../../copy");
var MeterReadsSummaryUI_1 = require("./ui/MeterReadsSummaryUI");
var components_1 = require("./ui/components");
var use_latest_billing_date_query_1 = require("./use-latest-billing-date-query");
exports.MeterReadsSummary = (0, core_1.withCustomerAndAccountIds)(function (_a) {
    var accountId = _a.accountId;
    var InfoNotification = (0, core_1.useComponents)().InfoNotification;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var _b = (0, mappings_1.useMeterReads)(accountId), readsData = _b.data, readsLoading = _b.loading, readsError = _b.error;
    var _c = (0, use_latest_billing_date_query_1.useLatestBillingDateQuery)(accountId), billingDateData = _c.data, billingDateLoading = _c.loading, billingDateError = _c.error;
    if (readsError || billingDateError) {
        return react_1.default.createElement(components_1.Error, { isFetching: false });
    }
    if (readsLoading || !readsData || billingDateLoading || !billingDateData) {
        return react_1.default.createElement(components_1.Loading, null);
    }
    if (!readsData ||
        (readsData.electricity.length === 0 && readsData.gas.length === 0)) {
        return (react_1.default.createElement(InfoNotification, { id: "info-no-active-supplies", title: react_1.default.createElement(Copy, { copyKey: "noActiveSuppliesTitle" }), "data-testid": "meter-readings-no-active-supplies" },
            react_1.default.createElement(Copy, { copyKey: "noActiveSuppliesMessage" })));
    }
    return (react_1.default.createElement(MeterReadsSummaryUI_1.MeterReadsSummaryUI, { combinedSupplies: readsData, latestBillingEndDate: billingDateData }));
}, components_1.Loading);
